import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import style from '../css/ChatList.module.css';
import HeaderBar from '../components/HeaderBar';
import AdminBottomTab from './AdminBottomTab';

function ChatList() {
	const [chats, setChats] = useState([]);
	const navigate = useNavigate();

	const fetchChats = async () => {
		try {
			const response = await fetch(
				'https://hometech-repairs.in/homeTech/get_all_chats.php'
			);
			const data = await response.json();

			if (data.chats) {
				const sortedChats = data.chats.sort((a, b) => {
					if (a.last_sender !== 'admin' && b.last_sender === 'admin') return -1;
					if (a.last_sender === 'admin' && b.last_sender !== 'admin') return 1;
					return 0;
				});
				setChats(sortedChats);
			} else {
				setChats([]);
			}
		} catch (error) {
			console.error('Error fetching chats:', error);
		}
	};

	useEffect(() => {
		fetchChats();
		const chatInterval = setInterval(fetchChats, 2000);
		return () => clearInterval(chatInterval);
	}, []);

	return (
		<div className={style.container}>
			<HeaderBar title={'Chat List'} />
			{chats.length === 0 ? (
				<p className={style.noChats}>No chats available</p>
			) : (
				<ul className={style.chatList}>
					{chats.map((chat) => (
						<li
							key={chat.guest_id}
							className={`${style.chatItem} ${
								chat.last_sender !== 'admin' ? style.highlight : style.cust
							}`}
							onClick={() => navigate(`/chat/${chat.guest_id}`)}
						>
							<span className={style.chatText}>{chat.guest_id}</span>
							<span className={style.arrow}>&#x2192;</span>
						</li>
					))}
				</ul>
			)}
			<AdminBottomTab />
		</div>
	);
}

export default ChatList;
